import { BaseProductVariant, ProductBuilderMachineContext } from '../types';
import { getBaseProductType } from './getBaseProductType';

type GetColourSample = (
  context: ProductBuilderMachineContext,
  title: string,
) => BaseProductVariant | undefined;

export const getColourSample: GetColourSample = (
  context: ProductBuilderMachineContext,
  title: string,
) => {
  const productType = getBaseProductType(context);
  const venetianType = context.products[0].type.replace('Venetian ', '');
  const rollerEssentialType = context.products[0].type;
  const colourSample =
    productType === 'Venetian'
      ? context.colourSamples[0].variants.find(
          variant =>
            variant.title.includes(title) &&
            variant.title.includes(venetianType),
        )
      : rollerEssentialType === 'Roller Blind Essentials Chain' &&
        productType === 'Roller Blind'
      ? context.colourSamples[0].variants.find(
          variant => variant.title.includes(title) && variant.title === title,
        )
      : productType === 'Honeycomb' ||
        productType === 'Shutter' ||
        productType === 'Roman Blinds' ||
        productType === 'Curtain' ||
        productType === 'Roller Blind'
      ? context.colourSamples[0].variants.find(variant =>
          variant.title.includes(title),
        )
      : undefined;
  return colourSample;
};
